/* ============
 * English Language File
 * ============
 *
 * An example language file.
 */

import * as auth from './auth.json';
import * as invoice from './invoice.json';

export default {
    auth,
    invoice,
};



// WEBPACK FOOTER //
// ./src/locale/en/index.js